<template>
  <b-modal
    v-model="modalShow"
    centered
    title="Create role"
    hide-footer
    size="lg"
    scrollable
  >
    <b-overlay :show="loadingData" variant="transparent" no-wrap />

    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="name"
                rules="required"
              >
                <b-form-input
                  v-model="formData.name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="description"
                rules="required"
              >
                <b-form-input
                  v-model="formData.description"
                  :state="errors.length > 0 ? false : null"
                  placeholder="description"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <h2>permissions</h2>

              <div v-for="(item, index) in formData.permissions" :key="index">
                <br />
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="name"
                    rules="required"
                  >
                    <b-form-input
                      v-model="item.name"
                      :state="errors.length > 0 ? false : null"
                      placeholder="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="slug"
                    rules="required"
                  >
                    <b-form-input
                      v-model="item.slug"
                      :state="errors.length > 0 ? false : null"
                      placeholder="slug"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-button
                  @click="removePermission(index)"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="warning"
                  class="btn-icon"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </div>
              <br />
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                @click="addPermission"
              >
                add
              </b-button>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationForm"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCardText,
  VBModal,
  BCard,
  BOverlay,
  BFormTextarea,
} from "bootstrap-vue";
import { required, integer } from "@validations";
import { mapActions } from "vuex";
import { BFormCheckbox } from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BCard,
    vSelect,
    VBModal,
    BOverlay,
    BFormTextarea,
    ToastificationContent,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      modalShow: false,
      formData: {
        name: null,
        description: null,
        permissions: [],
      },
      required,
      integer,
      loadingData: false,
    };
  },
  methods: {
    ...mapActions("role", ["store", "roles"]),
    async validationForm() {
      this.$refs.simpleRules
        .validate()
        .then(async (success) => {
          if (success) {
            try {
              this.loadingData = true;

              await this.store(this.formData);

              this.resetFormData();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Role added successfully",
                  icon: "CheckCircleIcon",
                  variant: "success",
                },
              });
              this.roles();
              this.modalShow = false;
            } catch (error) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error adding role",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                  text: `${error.message}`,
                },
              });
              console.log(error);
            } finally {
              this.loadingData = false;
            }
          }
        })
        .catch((error) => {
          this.$swal({
            title: "Error!",
            text: error.message,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        });
    },
    resetFormData() {
      this.formData = {
        name: null,
        description: null,
        permissions: [],
      };
    },
    addPermission() {
      this.formData.permissions.push({
        name: null,
        slug: null,
      });
    },
    removePermission(index) {
      this.formData.permissions.splice(index, 1);
    },
  },
};
</script>
